/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Disabled_WebsitesInputs */

const en_common_disabled_websites = /** @type {(inputs: Common_Disabled_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disabled Websites`)
};

const es_common_disabled_websites = /** @type {(inputs: Common_Disabled_WebsitesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitios deshabilitados`)
};

/**
* | output |
* | --- |
* | "Disabled Websites" |
*
* @param {Common_Disabled_WebsitesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_disabled_websites = /** @type {((inputs?: Common_Disabled_WebsitesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Disabled_WebsitesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_disabled_websites(inputs)
	return en_common_disabled_websites(inputs)
});